var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row justify-content-between p-2"},[_c('span',[_vm._v(_vm._s(_vm.item.title))]),_c('span',[_c('strong',[_vm._v(_vm._s(_vm._f("price")(_vm.item.price))+" ")])]),_c('button',{staticClass:"close",on:{"click":_vm.removeItemFromCart}},[_c('span',[_vm._v("×")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }